import { TCompanyFinalSchemaKey } from "../../models";
import {
  TLastFinalSchema,
  TLastFinalSchemaStorage,
} from "./final-schema.storage.helpers.models";
import { localStorageHelpers } from "./storage.helpers";

export const getSchemaKey = (companyId: number): TCompanyFinalSchemaKey => {
  return `${companyId}_lastFinalSchema`;
};

export const schemaMapToObject = (
  map: TLastFinalSchema,
): TLastFinalSchemaStorage => {
  return Object.fromEntries(map.entries()) as TLastFinalSchemaStorage;
};

export const getStoredFinalSchema = (
  companyId: number,
): TLastFinalSchemaStorage => {
  const storedFinalSchema =
    localStorageHelpers.getItem<TLastFinalSchemaStorage>(
      getSchemaKey(companyId),
    );

  return (storedFinalSchema || {}) as TLastFinalSchemaStorage;
};

export const getStoredFinalSchemaMap = (
  companyId: number,
): TLastFinalSchema => {
  const storedFinalSchema = getStoredFinalSchema(companyId);

  return new Map(Object.entries(storedFinalSchema)) as TLastFinalSchema;
};

export const setStoredFinalSchemaMap = (
  companyId: number,
  finalSchemaMap: TLastFinalSchema,
): void => {
  const schemaKey = getSchemaKey(companyId);

  localStorageHelpers.setItem<TLastFinalSchemaStorage>(
    schemaKey,
    schemaMapToObject(finalSchemaMap),
  );
};
